export default "__VITE_ASSET__C9PZ$QpT__$_?url__"